import { inject, Injectable } from '@angular/core';
import { Http, QueryHandlerFor } from '@skylab-angular-shared/core';
import { ConsoleLogger, HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { fillPlaceholders } from '@skylab-shared/utils';

export interface KsefGetCollectiveIdentifiersByKsefNumberQueryParams {
    ksefNumber: string;
}

export type KsefGetCollectiveIdentifiersByKsefNumberQueryResult = {
    collectiveIdentifiers: string[];
};

export class KsefGetCollectiveIdentifiersByKsefNumberQuery extends Query<KsefGetCollectiveIdentifiersByKsefNumberQueryResult | undefined> {
    public constructor(public readonly params: KsefGetCollectiveIdentifiersByKsefNumberQueryParams) {
        super();
    }
}

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(KsefGetCollectiveIdentifiersByKsefNumberQuery)
export class KsefGetCollectiveIdentifiersByKsefNumberQueryHandler implements QueryHandler<KsefGetCollectiveIdentifiersByKsefNumberQuery> {
    #url = TaggedUrl.join('eInvoices/collective-identifier/:ksefNumber', [Tags.Api, Tags.OmitMessage]);
    #logger = new ConsoleLogger(this.constructor.name);
    #http = inject(Http) as HttpService;

    public async handleAsync({ params }: KsefGetCollectiveIdentifiersByKsefNumberQuery): Promise<KsefGetCollectiveIdentifiersByKsefNumberQueryResult | undefined> {
        try {
            const url = fillPlaceholders(this.#url, { ksefNumber: params.ksefNumber });
            const { data } = await this.#http.get<KsefGetCollectiveIdentifiersByKsefNumberQueryResult>(url);
            return data;
        } catch (err) {
            this.#logger.error(err);
            return { collectiveIdentifiers: [] }
        }
    }
}
